import { db } from '@/store/firebase'
import firestoreUtil from '@/utils/firestore'
import firebase from 'firebase/app'

const state = {
  allPatientInteractions: []
}

const mutations = {
  setAllPatientInteractions (state, payload) {
    state.allPatientInteractions = payload || []
  }
}

const actions = {
  getAllPatientInteractions ({ commit }, patientId) {
    return db.collection('gestationInteraction')
      .where('patient.id', '==', patientId)
      // .orderBy('date', 'desc')
      .get()
      .then(query => {
        const interactions = query.docs.map(doc => firestoreUtil.docToObject(doc))
        commit('setAllPatientInteractions', interactions)
        return interactions
      })
  },

  saveFormData ({ commit }, { recordId, formData }) {
    console.log('saveFormData', recordId, formData)
    if (!recordId) return Promise.reject(new Error('ID do registro não fornecido'))

    // Agrupa as keys por formulário
    const formKeys = {}
    Object.keys(formData).forEach(key => {
      if (key.endsWith('.hasData')) return // Ignora keys hasData existentes
      const formKey = key.split('.')[0]
      if (!formKeys[formKey]) {
        formKeys[formKey] = []
      }
      formKeys[formKey].push(key)
    })

    // Monta o objeto para salvar, usando FieldValue.delete() para campos nulos/undefined
    const formsToSave = {}
    Object.keys(formData).forEach(key => {
      const value = formData[key]
      if (value === null || value === undefined) {
        formsToSave[key] = firebase.firestore.FieldValue.delete()
      } else {
        formsToSave[key] = value
      }
    })

    // Verifica quais formulários têm dados e adiciona hasData
    Object.entries(formKeys).forEach(([formKey, keys]) => {
      const hasData = keys.some(key => {
        const value = formData[key]
        return value !== null && value !== undefined && value !== ''
      })
      if (hasData) {
        formsToSave[`${formKey}.hasData`] = true
      } else {
        formsToSave[`${formKey}.hasData`] = firebase.firestore.FieldValue.delete()
      }
    })

    console.log(formsToSave)
    // se não houver dados para salvar, retorna
    if (Object.keys(formsToSave).length === 0) {
      return Promise.resolve()
    }
    return db.doc('gestationInteraction/' + recordId).set({ forms: formsToSave, status: 'ANDAMENTO' }, { merge: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/medicalRecord.js